import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import './Footer.css'; 

const Footer = () => {
    const handleScrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // Ensures smooth scrolling
        });

      };


  return (
    <footer className="footer  text-white py-4   jab_footer">
      <Container className='mt-3'>
        <Row>
    
          <Col md={6} className="mb-3 fw-bold" >
            <h5 className="text-uppercase fw-bold">Journal of Applied Bioanalysis</h5>
            <p className='mb-0'>Open Access</p>
            {/* <p  >Contact</p> */}
          </Col>

    
          <Col md={6}>
            <Row>
              <Col xs={6}>
                <ul className="list-unstyled">
                  <li><Link to="/" className="text-white text-decoration-none" onClick={handleScrollToTop}>Home</Link></li>
                  <li><Link to="/about" className="text-white text-decoration-none" onClick={handleScrollToTop}>About Us</Link></li>
                  
                  <li><Link to="/contact-us" className="text-white text-decoration-none" onClick={handleScrollToTop}>Contact Us</Link></li>
                  <li><Link to="/submit-article" className="text-white text-decoration-none" onClick={handleScrollToTop}>Submit Article</Link></li>
                  <li><Link to="/copyright" className="text-white text-decoration-none" onClick={handleScrollToTop}>Copyright</Link></li>
                </ul>
              </Col>
              <Col xs={6}>
                <ul className="list-unstyled">
                  <li><Link to="/privacy" className="text-white text-decoration-none" onClick={handleScrollToTop}>Privacy Policy</Link></li>
                  <li><Link to="/terms-condition" className="text-white text-decoration-none" onClick={handleScrollToTop}>Terms and Conditions</Link></li>
                  
                  <li><Link to="/journal-information" className="text-white text-decoration-none" onClick={handleScrollToTop}>Journal Information</Link></li>
                
                  <li><Link to="/editorial-board-journal-of-applied-bioanalysis" className="text-white text-decoration-none" onClick={handleScrollToTop}> Editorial</Link></li>
                  <li><Link to="/information/editorial-criteria-and-processes/0--how-to-submit-an-article-" className="text-white text-decoration-none" onClick={handleScrollToTop}> Editorial Criteria and Processes</Link></li>
                 
              
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className="border-secondary" />
        <Row className="text-center">
          <Col>
            <p className="mb-0">© Copyright 2025 </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
